<script>
  import BaseModal from './BaseModal.svelte';
  import Button from '../common/Button.svelte';
  
  export let isOpen = false;
  export let title = '확인';
  export let message = '';
  export let confirmText = '확인';
  export let cancelText = '취소';
  export let confirmVariant = 'primary';
  export let danger = false;
  export let icon = null;
  export let onConfirm = () => {};
  export let onCancel = () => {};

  function handleConfirm() {
    onConfirm();
    isOpen = false;
  }

  function handleCancel() {
    onCancel();
    isOpen = false;
  }

  function handleClose() {
    handleCancel();
  }

  $: iconMap = {
    warning: '⚠️',
    danger: '❌',
    success: '✅',
    info: 'ℹ️',
    question: '❓'
  };

  $: displayIcon = icon || (danger ? iconMap.danger : iconMap.question);
</script>

<BaseModal 
  bind:isOpen 
  {title}
  size="sm"
  on:close={handleClose}
>
  <div class="confirm-content">
    {#if displayIcon}
      <div class="confirm-icon" class:danger>
        {displayIcon}
      </div>
    {/if}
    <div class="confirm-message">
      {message}
    </div>
  </div>
  
  <div slot="footer" class="confirm-actions">
    <Button 
      variant="secondary" 
      on:click={handleCancel}
    >
      {cancelText}
    </Button>
    <Button 
      variant={danger ? 'danger' : confirmVariant}
      on:click={handleConfirm}
    >
      {confirmText}
    </Button>
  </div>
</BaseModal>

<style>
  .confirm-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: var(--spacing-lg);
  }

  .confirm-icon {
    font-size: 3rem;
    color: var(--info-color);
  }

  .confirm-icon.danger {
    color: var(--danger-color);
  }

  .confirm-message {
    font-size: var(--font-size-base);
    color: var(--text-color);
    line-height: var(--line-height-relaxed);
  }

  .confirm-actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-sm);
  }

  /* 반응형 디자인 */
  @media (max-width: 768px) {
    .confirm-actions {
      flex-direction: column-reverse;
      gap: var(--spacing-xs);
    }
  }
</style> 